/* @flow */
import * as React from "react";
import Backbone from "backbone";
import { createMuiTheme } from "@material-ui/core/styles";
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import ColorSets, {
  type ColorSet as ColorSet_,
  type ColorSetName as ColorSetName_,
} from "./ColorSets";

export type ColorSet = ColorSet_;
export type ColorSetName = ColorSetName_;

// eslint-disable-next-line no-process-env
const isCommercial = process.env.APP_BRAND === "commercial";

let currentColorSetName: ColorSetName = isCommercial ? "pivot" : "nexia";

const changeColorSetListener = { ...Backbone.Events };
changeColorSetListener.on("change", (newSetName: any) => {
  currentColorSetName = newSetName;
});

export function setColorSetName(colorSetName: ColorSetName) {
  changeColorSetListener.trigger("change", colorSetName);
}

type Props = {
  children: (colorSet: ColorSet) => React.Node,
};

export default class ColorsProvider extends React.Component<Props> {
  static _muiThemes: { [colorSetName: string]: Object } = {};

  _getMuiTheme(colorSetName: ColorSetName) {
    if (this.constructor._muiThemes[colorSetName]) {
      return this.constructor._muiThemes[colorSetName];
    }

    const colorSet = ColorSets[colorSetName];

    this.constructor._muiThemes[colorSetName] = createMuiTheme({
      fontFamily: "",
      palette: {
        primary: {
          main: colorSet.PRIMARY,
          pivot: colorSet.PRIMARY,
        },
        secondary: {
          main: colorSet.PRIMARY,
          pivot: colorSet.PRIMARY,
        },
        text: {
          main: colorSet.TEXT,
          pivot: colorSet.TEXT,
        },
      },
      overrides: {
        MuiRadio: {
          colorPrimary: {
            color: colorSet.PRIMARY,
          },
          colorSecondary: {
            color: colorSet.PRIMARY,
          },
        },
      },
      typography: {
        useNextVariants: true,
      },
    });

    return this.constructor._muiThemes[colorSetName];
  }

  componentDidMount() {
    changeColorSetListener.on(
      "change",
      () => {
        this.forceUpdate();
      },
      this
    );
  }

  componentWillUnmount() {
    changeColorSetListener.off(null, null, this);
  }

  render() {
    const { children } = this.props;
    const colorSet = ColorSets[currentColorSetName];

    return (
      <MuiThemeProvider theme={this._getMuiTheme(currentColorSetName)}>
        {children(colorSet)}
      </MuiThemeProvider>
    );
  }
}

export function withColorsProvider<
  InputProps: {
    colors: ColorSet,
  },
  WrappedComponent: React.ComponentType<InputProps>,
  OutputProps: $Diff<
    React.ElementConfig<WrappedComponent>,
    { colors: ColorSet }
  >
>(Component: WrappedComponent): React.ComponentType<OutputProps> {
  const displayName =
    Component.displayName || Component.name || "<anonymous component>";

  function ColoredComponent(props: OutputProps) {
    return (
      <ColorsProvider>
        {(colors) => <Component {...props} colors={colors} />}
      </ColorsProvider>
    );
  }

  ColoredComponent.displayName = `withColorsProvider(${displayName})`;

  return ColoredComponent;
}



// WEBPACK FOOTER //
// ../nx-components/src/ColorsProvider/index.jsx